export const CONTACT = {
  email: 'admin@dedariautomation.com',
  whatsapp: { href: 'https://wa.me/6282342470033', display: '+62 823 4247 0033' },
  instagram: { href: 'https://instagram.com/dedaribaliexport', handle: '@dedaribaliexport' },
  threads: { href: 'https://threads.net/@dedaribaliexport', handle: '@dedaribaliexport' },
};
